import { Component, ChangeDetectionStrategy, DestroyRef, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { VersionService } from '../../services/version.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'login',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly versionService = inject(VersionService);

  readonly versionString: string = this.versionService.getVersionString();

  loginObj = {
    Username: '',
    Password: ''
  };

  loginError = signal<string | null>(null);
  showPassword = signal(false);
  isLoggingIn = signal(false);

  togglePasswordVisibility(): void {
    this.showPassword.update(v => !v);
  }

  onLogin(): void {
    if (this.isLoggingIn()) return;

    this.loginError.set(null);
    this.isLoggingIn.set(true);

    this.authService.login(this.loginObj).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: () => {
        this.isLoggingIn.set(false);
        this.router.navigateByUrl('/dashboard');
      },
      error: (err) => {
        this.isLoggingIn.set(false);
        if (err && (err.status === 401 || err.status === 400)) {
          this.loginError.set('Incorrect username or password.');
        } else if (err instanceof Error) {
          this.loginError.set(err.message);
        } else {
          this.loginError.set('An unexpected error occurred. Please try again.');
        }
      }
    });
  }
}
